<h1 mat-dialog-title>
    {{
    (post ? "crud.actions.update" : "crud.actions.create") | translate
    }}
    post
</h1>
<form *ngIf="entityForm" [formGroup]="entityForm" mat-dialog-content class="content">
    <mat-form-field cdkFocusInitial *ngIf="post && post.horse?.sire">
        <mat-label>
            {{ "posts.actions.create.fields.sire" | translate }}
        </mat-label>
        <input matInput formControlName="sire" [value]="post && post.horse.sire" />
    </mat-form-field>
    <section *ngIf="post" formGroupName="horse_informations">
        <h1>
            {{ "posts.actions.create.sections.horse_informations" | translate }}
        </h1>
        <mat-form-field>
            <mat-label>
                {{ "posts.actions.create.fields.horse_name" | translate }}
            </mat-label>
            <input matInput formControlName="horse_name" />
        </mat-form-field>
        <mat-form-field>
            <mat-label>
                {{ "posts.actions.create.fields.horse_year" | translate }}
            </mat-label>
            <input matInput type="number" formControlName="horse_year"/>
        </mat-form-field>
        <mat-form-field>
            <mat-label>
                {{ "posts.actions.create.fields.horse_sex.label" | translate }}
            </mat-label>
            <mat-select formControlName="horse_sex">
                <mat-option value="male">
                    {{
                    "posts.actions.create.fields.horse_sex.options.male" | translate
                    }}
                </mat-option>
                <mat-option value="female">
                    {{
                    "posts.actions.create.fields.horse_sex.options.female" | translate
                    }}
                </mat-option>
                <mat-option value="hongre">
                    {{
                    "posts.actions.create.fields.horse_sex.options.hongre" | translate
                    }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field>
            <mat-label>
                {{ "posts.actions.create.fields.horse_total_earn" | translate }}
            </mat-label>
            <input matInput type="number" formControlName="horse_total_earn" />
        </mat-form-field>
        <mat-form-field>
            <mat-label>
                {{ "posts.actions.create.fields.horse_record.label" | translate }}
            </mat-label>
            <input matInput formControlName="horse_record"
                [placeholder]="'posts.actions.create.fields.horse_record.placeholder' | translate"/>
        </mat-form-field>
        <mat-form-field>
            <mat-label>
                {{ "posts.actions.create.fields.horse_father" | translate }}
            </mat-label>
            <input matInput formControlName="horse_father"/>
        </mat-form-field>
        <mat-form-field>
            <mat-label>
                {{ "posts.actions.create.fields.horse_mother" | translate }}
            </mat-label>
            <input type="text" matInput formControlName="horse_mother"/>
        </mat-form-field>
        <mat-form-field>
            <mat-label>
                {{ "posts.actions.create.fields.category.label" | translate }}
            </mat-label>
            <mat-select formControlName="category">
                <mat-option value="yearling">
                    {{"posts.actions.create.fields.category.options.yearling" | translate }}
                </mat-option>
                <mat-option value="training">
                    {{"posts.actions.create.fields.category.options.training" | translate }}
                </mat-option>
                <mat-option value="two_years">
                    {{"posts.actions.create.fields.category.options.two_years" | translate }}
                </mat-option>
                <mat-option value="out_training">
                    {{"posts.actions.create.fields.category.options.out_training" | translate }}
                </mat-option>
                <mat-option value="broodmare">
                    {{"posts.actions.create.fields.category.options.broodmare" | translate }}
                </mat-option>
                <mat-option value="stallion">
                    {{"posts.actions.create.fields.category.options.stallion" | translate }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field>
            <mat-label>
                {{ "posts.actions.create.fields.horse_location" | translate }}
            </mat-label>
            <input matInput formControlName="horse_location" />
        </mat-form-field>
        <mat-form-field>
            <mat-label>
                {{ "posts.actions.create.fields.sell_price" | translate }}
            </mat-label>
            <input matInput type="number" formControlName="sell_price" />
        </mat-form-field>
        <div style="
        display: flex;
        position: relative;
        width: 100%;
        gap: 5px;">
            <img [src]="post.photos[0]" *ngIf="post.photos && post.photos.length>0" alt="photo du cheval" style="
    object-fit: cover;
    object-position: center;
    width: auto;
    height: 38px;
    border-top-left-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
    z-index: 1;">
            <mat-form-field style="width: 100%;">
                <ngx-mat-file-input formControlName="horse_photos" [required]="true"
                    [valuePlaceholder]="'posts.actions.create.fields.horse_photos' | translate" [multiple]="true"
                    accept=".png,.jpeg,.jpg,.webp"></ngx-mat-file-input>
                <mat-icon matSuffix svgIcon="file-import"></mat-icon>
            </mat-form-field>
        </div>
        <div>
            <span *ngIf="getInHorse('horse_photos')?.value?.errors" style="color: red">
                {{
                getUploadErrors('horse_photos')["maxSize"] &&
                ("errors.upload_limit" | translate) + " 500 ko"
                }}
            </span>
        </div>
        <mat-form-field style="min-height: 160px;">
            <mat-label>
                {{
                (user?.moderator
                ? "posts.actions.create.fields.comments_fr"
                : "posts.actions.create.fields.comments"
                ) | translate
                }}
            </mat-label>
            <textarea matInput formControlName="comments_fr" style="min-height: 160px;"></textarea>
        </mat-form-field>
        <mat-form-field *ngIf="user?.moderator" style="min-height: 160px;">
            <mat-label>
                {{ "posts.actions.create.fields.comments_en" | translate }}
            </mat-label>
            <textarea matInput cdkTextareaAutosize formControlName="comments_en" ></textarea>
        </mat-form-field>
        <div class="simple-row">
            <div>
                <p>
                    {{ "posts.actions.create.fields.to_negociate.label" | translate }}
                </p>
                <mat-slide-toggle matInput formControlName="to_negociate">
                    {{
                    (this.getInHorse('to_negociate')?.value
                    ? "posts.actions.create.fields.to_negociate.options.yes"
                    : "posts.actions.create.fields.to_negociate.options.no"
                    ) | translate
                    }}
                </mat-slide-toggle>
            </div>
            <div>
                <p>
                    {{ "posts.actions.create.fields.taxable_vat.label" | translate }}
                </p>
                <mat-slide-toggle matInput formControlName="taxable_vat">
                    {{
                    (this.getInHorse('taxable_vat')?.value
                    ? "posts.actions.create.fields.taxable_vat.options.yes"
                    : "posts.actions.create.fields.taxable_vat.options.no"
                    ) | translate
                    }}
                </mat-slide-toggle>
            </div>
        </div>
    </section>
    <section *ngIf="post" formGroupName="documents">
        <h1>
            {{ "posts.actions.create.fields.documents.label" | translate }}
        </h1>
        <div style="
        display: flex;
        position: relative;
        width: 100%;
        gap: 5px;">
            <embed *ngIf="sanitizedHorseRegistration" [src]="sanitizedHorseRegistration"  style="
            object-fit: cover;
            object-position: center;
            width: auto;
            max-width: 100px;
            height: 38px;
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
            z-index: 1;"/>
            <mat-form-field style="width: 100%;">
                <ngx-mat-file-input formControlName="horse_registration" [required]="true"
                    [valuePlaceholder]="'posts.actions.create.fields.documents.options.horse_registration' | translate"
                    [multiple]="false" accept=".png,.jpeg,.jpg,.webp,.pdf"></ngx-mat-file-input>
                <mat-icon matSuffix svgIcon="file-import"></mat-icon>
            </mat-form-field>
            <div>
                <span *ngIf="getInDocuments('documents_horse_registration')?.value?.errors" style="color: red">
                    {{
                    getUploadErrors('documents_horse_registration')["maxSize"] &&
                    ("errors.upload_limit" | translate) + " 500 ko"
                    }}
                </span>
            </div>
        </div>
        <div style="
        display: flex;
        position: relative;
        width: 100%;
        gap: 5px;">
            <embed *ngIf="sanitizedCertificateOfSale" [src]="sanitizedCertificateOfSale"  style="
            object-fit: cover;
            object-position: center;
            width: auto;
            height: 38px;
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
            z-index: 1;"/>
            <mat-form-field style="width: 100%;">
                <ngx-mat-file-input formControlName="certificate_of_sale" [required]="isCoowner()"
                    [valuePlaceholder]="'posts.actions.create.fields.documents.options.certificate_of_sale' | translate"
                    [multiple]="false" accept=".png,.jpeg,.jpg,.webp,.pdf"></ngx-mat-file-input>
                <mat-icon matSuffix svgIcon="file-import"></mat-icon>
            </mat-form-field>
            <div>
                <span *ngIf="getInDocuments('documents_certificate_of_sale')?.value?.errors" style="color: red">
                    {{
                    getUploadErrors('documents_certificate_of_sale')["maxSize"] &&
                    ("errors.upload_limit" | translate) + " 500 ko"
                    }}
                </span>
            </div>
        </div>
        <div style="
        display: flex;
        position: relative;
        width: 100%;
        gap: 5px;">
            <embed *ngIf="sanitizedCertificationOfThePerson" [src]="sanitizedCertificationOfThePerson"  style="
            object-fit: cover;
            object-position: center;
            width: auto;
            height: 38px;
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
            z-index: 1;"/>
            <mat-form-field style="width: 100%;">
                <ngx-mat-file-input formControlName="certification_of_the_person" [required]="isAgent()"
                    [valuePlaceholder]="'posts.actions.create.fields.documents.options.certification_of_the_person' | translate"
                    [multiple]="false" accept=".png,.jpeg,.jpg,.webp,.pdf"></ngx-mat-file-input>
                <mat-icon matSuffix svgIcon="file-import"></mat-icon>
            </mat-form-field>
            <div>
                <span *ngIf="getInDocuments('documents_certification_of_the_person')?.value?.errors" style="color: red">
                    {{
                    getUploadErrors('documents_certification_of_the_person')[
                    "maxSize"
                    ] && ("errors.upload_limit" | translate) + " 500 ko"
                    }}
                </span>
            </div>
        </div>
        <div style="
        display: flex;
        position: relative;
        width: 100%;
        gap: 5px;">
            <embed *ngIf="sanitizedExtractKbis" [src]="sanitizedExtractKbis"  style="
            object-fit: cover;
            object-position: center;
            width: auto;
            height: 38px;
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
            z-index: 1;"/>
            <mat-form-field style="width: 100%;">
                <ngx-mat-file-input formControlName="extract_kbis" [required]="false"
                    [valuePlaceholder]="'posts.actions.create.fields.documents.options.extract_kbis' | translate"
                    [multiple]="false" accept=".png,.jpeg,.jpg,.webp,.pdf"></ngx-mat-file-input>
                <mat-icon matSuffix svgIcon="file-import"></mat-icon>
            </mat-form-field>
            <div>
                <span *ngIf="getInDocuments('documents_extract_kbis')?.value?.errors" style="color: red">
                    {{ getUploadErrors('documents_extract_kbis')["maxSize"] && ("errors.upload_limit" | translate)
                    + " 500 ko" }}
                </span>
            </div>
        </div>
    </section>
    <section formGroupName="contact_informations" *ngIf="post">
        <h1>
            {{ "posts.actions.create.sections.contact_informations" | translate }}
        </h1>
        <div class="row">
            <mat-form-field>
                <mat-label>
                    {{ "posts.actions.create.fields.last_name" | translate }}
                </mat-label>
                <input matInput formControlName="last_name" />
            </mat-form-field>
            <mat-form-field>
                <mat-label>
                    {{ "posts.actions.create.fields.first_name" | translate }}
                </mat-label>
                <input matInput formControlName="first_name" />
            </mat-form-field>
        </div>
        <mat-form-field>
            <mat-label>
                {{ "posts.actions.create.fields.email" | translate }}
            </mat-label>
            <input matInput type="email" formControlName="email" />
        </mat-form-field>
        <mat-form-field>
            <mat-label>
                {{ "posts.actions.create.fields.role.label" | translate }}
            </mat-label>
            <mat-select formControlName="role" >
                <mat-option value="unique_owner">
                    {{"posts.actions.create.fields.role.options.unique_owner" | translate }}
                </mat-option>
                <mat-option value="stable_manager">
                    {{"posts.actions.create.fields.role.options.stable_manager" | translate }}
                </mat-option>
                <mat-option value="coowner">
                    {{ "posts.actions.create.fields.role.options.coowner" | translate }}
                </mat-option>
                <mat-option value="agent">
                    {{ "posts.actions.create.fields.role.options.agent" | translate }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field>
            <mat-label>
                {{ "posts.actions.create.fields.mobile_phone_number" | translate }}
            </mat-label>
            <input matInput formControlName="mobile_phone_number" type="tel" />
        </mat-form-field>
        <mat-form-field>
            <mat-label>
                {{ "posts.actions.create.fields.landline_phone_number" | translate }}
            </mat-label>
            <input matInput formControlName="landline_phone_number" type="tel" />
        </mat-form-field>
        <p>
            {{ "posts.actions.create.fields.contact_is_english.label" | translate }}
        </p>
        <mat-slide-toggle matInput formControlName="is_english">
            {{
            (getInContact('contact_is_english')?.value
            ? "posts.actions.create.fields.contact_is_english.options.yes"
            : "posts.actions.create.fields.contact_is_english.options.no"
            ) | translate
            }}
        </mat-slide-toggle>
        <p>
            {{ "posts.actions.create.fields.mail_confirmation.label" | translate }}
        </p>
        <mat-slide-toggle matInput formControlName="mail_confirmation">
            {{
            (getInContact('mail_confirmation')?.value
            ? "posts.actions.create.fields.mail_confirmation.options.yes"
            : "posts.actions.create.fields.mail_confirmation.options.no"
            ) | translate
            }}
        </mat-slide-toggle>
    </section>
</form>
<div mat-dialog-actions class="action-buttons" *ngIf="entityForm">
    <button mat-button (click)="cancel()">
        {{ "crud.actions.cancel" | translate }}
    </button>
    <button mat-flat-button [disabled]="!(post)" color="primary" (click)="save()">
        {{ "crud.actions.save" | translate }}
    </button>
<!--    <button mat-flat-button [mat-dialog-close]="entityUpdate" [disabled]="!entityForm.valid" color="primary">-->
<!--        {{-->
<!--        (post ? "crud.actions.update" : "crud.actions.create") | translate-->
<!--        }}-->
<!--    </button>-->
</div>
